import { BaseService } from "../service/BaseService";

export interface ServiceData {
  entity?: any;

  billName: string;
  loadListApiName: string;
  loadAllListApiName: string;
  loadFullListApiName: string;
  deleteListApiName: string;
  loadApiName: string;
  saveApiName: string;
}

export interface ServiceContext {
  serviceData: ServiceData;
  service: BaseService;

  entity?: any;

  statesName?: string;
  typesName?: string;

  listUrl: string;
  detailUrl: string;
}

export class ServiceFactory {
  static build(billName: string, apiPre: string, urlPre: string, service: BaseService) {
    const serviceData: ServiceData = {
      loadAllListApiName: "/api" + apiPre + "/list",
      loadFullListApiName: "/api" + apiPre + "/list/full",
      loadListApiName: "/api" + apiPre + "/list/query",
      deleteListApiName: "/api" + apiPre + "/delete",
      loadApiName: "/api" + apiPre + "/entity",
      saveApiName: "/api" + apiPre + "/save",
      billName: billName
    };

    service.serviceData = serviceData;
    const serviceContext: ServiceContext = {
      serviceData: serviceData,
      statesName: "sys-state",
      listUrl: urlPre + "/list",
      detailUrl: urlPre + "/detail",
      service
    };
    return serviceContext;
  }
}
